import { createSlice } from "@reduxjs/toolkit"

import { setActiveProductFiltersHandler } from "./buildingReferenceActionHandlers"

export interface BuildingReferenceState {
  activeProductFilters: string[]
}

export type BuildingReferenceReducerState = Record<
  string,
  BuildingReferenceState
>

const initialState: BuildingReferenceReducerState = {}

const buildingReferenceSlice = createSlice({
  name: "buildingReference",
  initialState,
  reducers: {
    setActiveProductFilters: setActiveProductFiltersHandler
  }
})

export const { setActiveProductFilters } = buildingReferenceSlice.actions

export const buildingReferenceActions = buildingReferenceSlice.actions

export default buildingReferenceSlice.reducer
